import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BreadcrumbNavigation = ({ archiveData }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const breadcrumbItems = [
    { label: 'Dashboard', path: '/', icon: 'Home' },
    { label: 'Archive History', path: '/archive-details', icon: 'History' },
    { label: `Archive #${archiveData?.id}`, path: null, icon: 'FileText' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between">
        {/* Breadcrumb */}
        <nav className="flex items-center space-x-2 text-sm">
          {breadcrumbItems?.map((item, index) => (
            <React.Fragment key={index}>
              {index > 0 && (
                <Icon name="ChevronRight" size={14} className="text-muted-foreground" />
              )}
              
              {item?.path ? (
                <Link
                  to={item?.path}
                  className="flex items-center space-x-1 text-muted-foreground hover:text-foreground transition-smooth"
                >
                  <Icon name={item?.icon} size={14} />
                  <span>{item?.label}</span>
                </Link>
              ) : (
                <div className="flex items-center space-x-1 text-foreground font-medium">
                  <Icon name={item?.icon} size={14} />
                  <span>{item?.label}</span>
                </div>
              )}
            </React.Fragment>
          ))}
        </nav>

        {/* Navigation Actions */}
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            iconName="ArrowLeft"
            iconPosition="left"
            onClick={handleGoBack}
          >
            Go Back
          </Button>
          
          <Link to="/webpage-notarization">
            <Button
              variant="default"
              size="sm"
              iconName="Plus"
              iconPosition="left"
            >
              New Archive
            </Button>
          </Link>
        </div>
      </div>
      {/* Archive Summary */}
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex items-start justify-between">
          <div className="flex-1 min-w-0">
            <h2 className="text-lg font-semibold text-foreground truncate" title={archiveData?.originalUrl}>
              {archiveData?.title || new URL(archiveData.originalUrl)?.hostname}
            </h2>
            <p className="text-sm text-muted-foreground mt-1 truncate" title={archiveData?.originalUrl}>
              {archiveData?.originalUrl}
            </p>
            <div className="flex items-center space-x-4 mt-2 text-xs text-muted-foreground">
              <div className="flex items-center space-x-1">
                <Icon name="Calendar" size={12} />
                <span>Archived {archiveData?.timestamp}</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="Zap" size={12} />
                <span>Polygon Network</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="CheckCircle" size={12} className="text-success" />
                <span className="text-success">Verified</span>
              </div>
            </div>
          </div>

          {/* Status Badge */}
          <div className="flex-shrink-0 ml-4">
            <div className="flex items-center space-x-2 px-3 py-1 bg-success/10 text-success rounded-full text-xs font-medium">
              <div className="w-2 h-2 bg-success rounded-full animate-pulse-subtle" />
              <span>Active</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreadcrumbNavigation;